
import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'

export default function AgentNetTypeBasicInfoComponent({  selectedAgentnetType, handleInnerFormChange }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
             <InputContainer
            isDisabled
              label="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                );
              }}
              type="text"
              value={selectedAgentnetType?.Name}
            />
          </div>

        }
        expandedPanel="basicInfo"
        headerTitle="Basic Information"
      />

    </>
  )
}